import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { JobSliderComponent } from './job-slider/job-slider.component';
import { ModelNewComponent } from './model-new.component';
import { InlineSliceComponent } from './inline-slice/inline-slice.component';
import { CrosslineSliceComponent } from './crossline-slice/crossline-slice.component';
import { MyViewerComponent, SignificantFiguresPipe } from './my-viewer/my-viewer.component';
import { DepthSliceComponent } from './depth-slice/depth-slice.component';
import { SettingsBoxComponent } from './settings-box/settings-box.component';
import { VerticalProfileComponent } from './vertical-profile/vertical-profile.component';
import { SearchableInputListPipe } from '../../../shared/pipes/searchable-input-list.pipe';

@NgModule({
  declarations: [
    JobSliderComponent,
    InlineSliceComponent,
    CrosslineSliceComponent,
    DepthSliceComponent,
    MyViewerComponent,
    ModelNewComponent,
    SearchableInputListPipe,
  ],
  exports: [
    JobSliderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SignificantFiguresPipe,
    SettingsBoxComponent,
    VerticalProfileComponent
  ]
})
export class ModelNewModule { }
